import { render, staticRenderFns } from "./qxOrderTab.vue?vue&type=template&id=58f00d49&scoped=true"
import script from "./qxOrderTab.vue?vue&type=script&lang=js"
export * from "./qxOrderTab.vue?vue&type=script&lang=js"
import style0 from "./qxOrderTab.vue?vue&type=style&index=0&id=58f00d49&prod&lang=scss&scoped=true"
import style1 from "./qxOrderTab.vue?vue&type=style&index=1&id=58f00d49&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f00d49",
  null
  
)

export default component.exports